import React from "react";
import * as images from "../../src/Constant/images";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import ContactSources from "../Components/Commom/ContactSources";

const banksData = {
  active: [
    {
      id: "faysal-main",
      bankName: "Faysal Bank Limited",
      logo: images.faysiallogo,
      logoScale: 1,
      accountTitle: "FAREMAKERS TRAVEL & TOURS ( PRIVATE) LTD",
      accountNumber: "3582499000004595",
      ibanNumber: "PK87FAYS3582499000004595",
    },
    {
      id: "hbl-main",
      bankName: "Habib Bank Limited",
      logo: images.hbllogo,
      logoScale: 1.05,
      accountTitle: "FAREMAKERS MALL SMC PVT LTD",
      accountNumber: "1060-7901327203",
      ibanNumber: "PK88HABB0010607901327203",
    },
  ],
  inactive: [
    {
      id: "hbl-old",
      bankName: "Habib Bank Limited",
      logo: images.hbllogo,
      logoWidth: "40px",
      accountTitle: "Faremakers Travel & Tours Pvt Ltd",
      accountNumber: "1060-7900329303",
      ibanNumber: "",
    },
    {
      id: "scb",
      bankName: "Standard Chartered",
      logo: images.SCBank,
      logoWidth: "15px",
      accountTitle: "Faremakers Travel & Tours Pvt Ltd",
      accountNumber: "01-7011197-01",
      ibanNumber: "",
    },
    {
      id: "meezan",
      bankName: "Meezan Bank",
      logo: images.MBBank,
      logoWidth: "25px",
      accountTitle: "Faremakers Travel & Tours Pvt Ltd",
      accountNumber: "0287-0101682411",
      ibanNumber: "",
    },
  ],
};

const BankCard = ({ bank, isInactive = false }) => {
  return (
    <div className="col-md-5 col-sm-6 habib_bank_details">
      <div
        className={
          isInactive
            ? "bank_card_wrapper bank_card_inactive"
            : "bank_card_wrapper"
        }
      >
        <div className="hbl_header d-flex justify-content-center align-items-center">
          <div className="bank_logo_wrap">
            <img
              src={bank.logo}
              alt={bank.bankName}
              className="bank_logo_image"
              style={{ transform: `scale(${bank.logoScale || 1})` }}
            />
          </div>
          <p className="hbl_name mb-0">{bank.bankName}</p>
        </div>
        <div className="hbl_body">
          <div className="accounts_details d-flex justify-content-start">
            <p className="account_title align-self-center ">Account Title:</p>
            <p className="align-self-center account_title_body ">
              {bank.accountTitle}
            </p>
          </div>
          <div className="accounts_details d-flex justify-content-start">
            <p className="account_title align-self-center">Account Number:</p>
            <p className="account_title_body">{bank.accountNumber}</p>
          </div>
          {bank.ibanNumber ? (
            <div className="accounts_details d-flex justify-content-start">
              <p className="account_title align-self-center">IBAN Number:</p>
              <p className="account_title_body">{bank.ibanNumber}</p>
            </div>
          ) : null}
          {isInactive ? (
            <div className="accounts_details d-flex justify-content-start">
              <p className="account_title align-self-center">Status:</p>
              <p className="account_title_body">Inactive</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const FMBanks = () => {
  return (
    <div className="container fm_banks_page">
      <div className="contact_us_heading d-flex justify-content-center">
        <AccountBalanceRoundedIcon className="about_detail_icon " />
        <h3 className="fmBanks_main_heading">
          Faremakers Travel & Tours Official Bank Accounts:
        </h3>
      </div>
      <div className="banks_main">
        <div className="row justify-content-center">
          {banksData.active.map((bank) => (
            <BankCard key={bank.id} bank={bank} />
          ))}

          <div className="help_desk">
            <ContactSources variant="modern" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FMBanks;
